module.exports = __webpack_public_path__ + "static/media/tick.e0b67037.svg";